import React, {Component} from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import './inAppOrderList.scss'
import moment from "moment";

import PageTitle from "../../../components/common/PageTitle";
import FeatherIcon from 'feather-icons-react';

//import images
import {reactLocalStorage as Storage} from "reactjs-localstorage";
import {Link} from "react-router-dom";



let model = {
  store: {
    name: '',
    domain: '',
    logo: '',
    platform: '',
    platformId: '',
    addrMain: '',
    addrSub: '',
    presidentName: '',
    tel: '',
    email: '',
    notificationEmail: '',
    customerService: {},
    privacyOfficer: {},
    pTeamUser_id: ''
  }
}

// model.store = {
//   name: '온노마드',
//   domain: 'http://onnomad.co.kr/',
//   logo: '',
//   platform: 'nhn_godo',
//   platformId: '',
//   addrMain: '서울시 성동구 상원1길 25 ',
//   addrSub: '4160호 (주)온노마드',
//   presidentName: '윤정진',
//   tel: '02-6417-7000',
//   email: '',
//   notificationEmail: 'godrium@naver.com',
//   customerService: {},
//   privacyOfficer: {},
//   pTeamUser_id: ''
// }

@inject(({ common }) => ({ setIsShowPopup: common.setIsShowPopup, isShowModal: common.isShowModal, getIsShowPopup: common.getIsShowPopup  }))
@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me:teamUser.me, getInAppOrderList: teamUser.getInAppOrderList }))
@inject(({ company }) => ({ updateStore:company.updateStore  }))

@observer
class InAppOrderList extends Component {

  //basic
  @observable store = {};

  @observable teamUser = {};
  @observable permissions = {}
  // @observable company = {};
  @observable isLogin = false;
  @observable isLoading = true;
  @observable urlParams = new URLSearchParams(window.location.search);

  @observable listParams = {page:1, limit:20};
  @observable boardList = [];
  @observable isPopupOpen = false;

  constructor(props) {
    super(props);
    this.init()

    // this.onChangeValue = this.onChangeValue.bind(this);
    // this.onSubmit = this.onSubmit.bind(this);
    // this.delTeamUser = this.delTeamUser.bind(this);
    // this.updateStore = this.updateStore.bind(this);
    // this.openPostCode = this.openPostCode.bind(this);
    // this.closePostCode = this.closePostCode.bind(this);
    // this.setAddress = this.setAddress.bind(this);
    // this.getTeamUserList = this.getTeamUserList.bind(this);
  }


  componentDidUpdate(prevProps, prevState){

  }

  @action
  init = async (key) => {

    if(this.props.isLogin) {
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.teamUser.email = this.teamUser.email ? this.teamUser.email : this.teamUser.emailId;
      this.store = this.props.me.store ? this.props.me.store : model.store;
      this.listParams.store_id = this.store._id;


      this.permissions = this.props.me.permissions;
      if(this.teamUser.isSuper && this.listParams.store_id) {
        this.getList();
      }
    }
    else {

      if(Storage.get('token')) {
        //todo 재확인 - 로그인 후 해당 페이지로 넘어 오는 경우 authCheck() 함수 미샐행 할 수 있게.
        //this.props.authCheck();
      }
      // else {
      //   window.location.replace('signIn');
      // }

    }
  };

  @action
  getList =async() => {
    this.boardList = await this.props.getInAppOrderList(this.listParams);
    console.log(this.boardList)
  };

  render() {

    function PaySuccess(props) {
      let statusStr = '';
      let paySuccess = props.paySuccess;
      switch (paySuccess){
        case 'fail' :
          statusStr = '결제실패';
          break;
        case 'ing' :
          statusStr = '결제중';
          break;
        case 'refund' :
          statusStr = '환불완료';
          break;
        case 'isSuspended' :
          statusStr = '이용정지';
          break;
        case 'success' :
          statusStr = '결제완료';
          break;

        default :
          statusStr = paySuccess;
          break;
      }
      return statusStr;
    }

    function EtcContent(props) {
      let statusStr = '';
      let order = props.order;
      switch (order.paySuccess){
        case 'fail' :
          statusStr = '';
          break;
        case 'ing' :
          statusStr = '';
          break;
        case 'refund' :
          statusStr = '환불금액 : ' + new Intl.NumberFormat('ko-KR', {currency: 'KRW'}).format(order.refundPrice) + "원";
          break;
        case 'isSuspended' :
          statusStr = '';
          break;
        case 'success' :
          statusStr = '';
          break;

        default :
          statusStr = order.paySuccess;
          break;
      }
      return statusStr;
    }

    return (
      <div className="main-content">
        <PageTitle />

        {/* 자동 결제 해지 방법 안내 — 외부 매뉴얼 페이지로 이동 */}
        <div style={{display:'flex', justifyContent:'flex-end', alignItems:'center', margin:'8px 0 12px'}}>
          <a
            href="https://onnomad.co.kr/manual/review-solution-onreple?ch=6968913a42b69734a5432550&sec=6968919142b69734a54325b7"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display:'inline-flex', alignItems:'center', gap:6,
              padding:'8px 14px',
              background:'#F3F4F6', color:'#1F2937',
              border:'1px solid #D1D5DB', borderRadius:6,
              fontSize:13, fontWeight:600,
              textDecoration:'none'
            }}
            title="자동 결제 해지 방법 안내 (새 창)"
          >
            <FeatherIcon icon="help-circle" size="14"/>
            자동 결제 해지 방법
            <FeatherIcon icon="external-link" size="12"/>
          </a>
        </div>

        <div className="section-box basic-info-table">
          {/*<div className="section-tit">*/}
          {/*  <h3>결제 내역</h3>*/}
          {/*</div>*/}
          <table>
            <thead>
            <tr>
              <th>결제일</th>
              <th>멀티샵</th>
              <th>결제 상품명</th>
              <th>결제 금액</th>
              <th>사용 기간</th>
              <th>상태</th>

              <th>기타</th>
            </tr>
            </thead>
            <tbody>
            {this.boardList && this.boardList.docs && this.boardList.docs.length > 0 ?
                this.boardList.docs.map((item, i) => (
                    <tr key={i}>
                      <td className="text-center">{moment(item.createdAt).format('YYYY.MM.DD HH:mm')}</td>
                      <td>{item.shop ? item.shop.shopName : ''}</td>
                      <td className="text-center">{item.plan}</td>
                      <td className="text-right">{new Intl.NumberFormat('ko-KR', {currency: 'KRW'}).format(item.orderAmount) + "원"}</td>
                      {item.automaticPayment === "T" && moment(item.endDate).isAfter(moment()) ? (
                              <td>{item.startDate} {item.startDate ? (moment(item.startDate).format('YYYY.MM.DD') ) + " ~" : "구독중"}  </td>
                          )
                          : (
                              <td>{moment(item.orders && item.orders[0].startDate ? item.orders[0].startDate : item.startDate).format('YYYY.MM.DD')} ~ {moment(item.endDate).format('YYYY.MM.DD')}</td>
                          )
                      }
                      {/*{item.paySuccess === "success" && moment(item.endDate).isAfter(moment()) ? (*/}
                      {/*        <td>사용중</td>*/}
                      {/*    )*/}
                      {/*    : (*/}
                      {/*        <td>사용정지</td>*/}
                      {/*    )*/}
                      {/*}*/}
                      <td className="text-center"><PaySuccess paySuccess={item.paySuccess} /></td>
                      {/*<td>{item.payType}</td>*/}
                      <td>
                        <EtcContent order={item} />
                      </td>
                    </tr>
                ))
                : (
                    <tr>
                      <td colSpan="7" className="text-center mt-auto">결제내역이 없습니다.</td>
                    </tr>)
            }
            </tbody>
          </table>
        </div>

        {this.isLogin && (
            <>
              <div style={{ marginTop: '30px', padding: '25px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef' }}>
                <h5 style={{ marginBottom: '15px', fontWeight: 600 }}>
                  <FeatherIcon icon="info" size="18" style={{ marginRight: '6px', verticalAlign: 'text-bottom' }} />
                  결제 후 처음인 경우
                </h5>
                <p style={{ marginBottom: '15px', color: '#555', fontSize: '14px', lineHeight: '1.7' }}>
                  서비스를 시작하려면 아래 설정을 순서대로 진행해 주세요.
                </p>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                  <Link to="/easySetting" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '10px 18px', backgroundColor: '#007bff', color: '#fff', borderRadius: '6px', textDecoration: 'none', fontSize: '14px', fontWeight: 500 }}>
                    <FeatherIcon icon="settings" size="15" /> 설치 & 연동 설정
                  </Link>
                  <Link to="/reviewWriteConfig" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '10px 18px', backgroundColor: '#28a745', color: '#fff', borderRadius: '6px', textDecoration: 'none', fontSize: '14px', fontWeight: 500 }}>
                    <FeatherIcon icon="edit-3" size="15" /> 리뷰 설정
                  </Link>
                </div>
              </div>

              <div style={{ marginTop: '15px', padding: '25px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef' }}>
                <h5 style={{ marginBottom: '15px', fontWeight: 600 }}>
                  <FeatherIcon icon="info" size="18" style={{ marginRight: '6px', verticalAlign: 'text-bottom' }} />
                  재결제 하신 경우
                </h5>
                <p style={{ marginBottom: '15px', color: '#555', fontSize: '14px', lineHeight: '1.7' }}>
                  기존 서비스를 계속 이용하시려면 스킨 활성화 설정을 확인해 주세요.
                </p>
                <div>
                  <Link to="/easySetting" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '10px 18px', backgroundColor: '#007bff', color: '#fff', borderRadius: '6px', textDecoration: 'none', fontSize: '14px', fontWeight: 500 }}>
                    <FeatherIcon icon="settings" size="15" /> 스킨 활성화 설정
                  </Link>
                </div>
              </div>
            </>
        )}
      </div>
    )
  }
}

export default InAppOrderList;
